module.exports = __webpack_public_path__ + "img/readycall_logo.4155dde3.png";